"use client";

import { useEffect } from "react";
import { getLocaleConfig, type Locale } from "@/config/locale";

/** The shared root layout survives soft navigation; the committed locale owns its language. */
export function DocumentLanguage({ locale }: { locale: Locale }) {
	const htmlLang = getLocaleConfig(locale).htmlLang;

	useEffect(() => {
		if (document.documentElement.lang !== htmlLang) {
			document.documentElement.lang = htmlLang;
		}
		// Do not restore the old value on unmount: the next locale owns the same document.
	}, [htmlLang]);

	return null;
}
